import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TbDatabaseExclamation, TbDatabaseEdit, TbDatabaseX } from 'react-icons/tb';
import Styles from './OutputPane.module.scss';

export function OutputPane({
    results,
    open: openProp,
    t
}) {
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
    }, [openProp]);

    useEffect(() => {
        setActiveTab(0);
    }, [results.length]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const TableView = ({ columns, data, message }) => {
        if (message) {
            return (
                <div className={Styles.queryMessage}>
                    <TbDatabaseEdit className={Styles.queryMessageIcon} />
                    <p className={Styles.queryMessageText}>{message}</p>
                </div>
            );
        }

        if (!data || data.length === 0) {
            return (
                <div className={Styles.noRecords}>
                    <TbDatabaseX className={Styles.noRecordsIcon} />
                    <p className={Styles.noRecordsText}>{t('Labs.Nodes.NodeSQL.output.records')}</p>
                </div>
            );
        }

        return (
            <div className={Styles.tableContainer}>
                <table>
                    <thead>
                        <tr>
                            {columns.map((col, i) => (
                                <th title={col} key={i}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => (
                                    <td title={cell} key={j}>{cell}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={activeTab} onChange={handleTabChange} sx={{
                    minHeight: 32,
                    "& .MuiTab-root": {
                        minHeight: 32,
                        minWidth: 58,
                        padding: "2px 8px",
                        fontSize: "0.75rem",
                    }
                }}>
                    {results.length > 0 ? (
                        results.map((_, i) => (
                            <Tab key={i} label={`Query ${i + 1}`} />
                        ))
                    ) : (
                        <Tab label="1" />
                    )}
                </Tabs>
            </Box>
            {results && (
                <div>
                    {results.error ? (
                        <div className={Styles.errorMessage}>
                            <TbDatabaseExclamation className={Styles.errorIcon} />
                            <p className={Styles.errorText}>{results.error}</p>
                        </div>
                    ) : (
                        <TableView
                            columns={results[activeTab]?.columns}
                            data={results[activeTab]?.values}
                            message={results.message}
                        />
                    )}
                </div>
            )}
        </>
    );
}
